// These constant exists because app/containers/NestedTeamList/sagas.js needs to be notified when
// archiving and restoring teams via redux action dispatch. If NestedTeamList is converted to react-query then
// this action file and the constant file should be deleted.

export const ARCHIVE_TEAM_SUCCESS =
  'app/SettingsTeamsPage/ARCHIVE_TEAM_SUCCESS';
export const RESTORE_TEAM_SUCCESS =
  'app/SettingsTeamsPage/RESTORE_TEAM_SUCCESS';
